module.exports = {"title":"Photos","popover":"Here you can upload photos for your guardians to view.","addPhotoButton":"Add photo +","meta":"Photos"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/en/photos.json
// module id = oTUP
// module chunks = 1